var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"story-thumbnail",class:[{ 'story-thumbnail--viewed': _vm.viewed }],style:(("background-image: url('" + _vm.img + "'); background-color: " + _vm.bgColor)),on:{"click":function($event){return _vm.$emit('click')}}},[_c('h3',{staticClass:"story-thumbnail__title",style:(("color: " + _vm.textColor + ";"))},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/stories/StoryThumbnail.vue?vue&type=template&id=1b8b9710&
// module id = 892
// module chunks = 0